import { attributesConstants } from '../constants'

const initialState = {
  loading: false,
  error: null,
  dashboard: null,
  detections: null
}

export default function attributes (state = initialState, action) {
  switch (action.type) {
    case attributesConstants.LOAD_ATTRIBUTES:
      return { ...state,
        loading: true,
        error: null
      }
    case attributesConstants.LOAD_ATTRIBUTES_DASHBOARD_SUCCESS:
      return { ...state,
        dashboard: action.payload,
        loading: false,
        error: null
      }
    case attributesConstants.LOAD_ATTRIBUTES_DETECTIONS_SUCCESS:
      return { ...state,
        detections: action.payload,
        loading: false,
        error: null
      }
    case attributesConstants.LOAD_ATTRIBUTES_FAILURE:
      return { ...initialState,
        error: action.payload,
        loading: false
      }
    case attributesConstants.RESET_ATTRIBUTES:
      return initialState
    default:
      return state
  }
}
